import {
    GET_CHAT_TAGS_STARTED,
    GET_CHAT_TAGS_SUCCESS,
    GET_CHAT_TAGS_FAILED,
    CREATE_CHAT_TAG_STARTED,
    CREATE_CHAT_TAG_SUCCESS,
    CREATE_CHAT_TAG_FAILED,
    UPDATE_CHAT_TAG_STARTED,
    UPDATE_CHAT_TAG_SUCCESS,
    UPDATE_CHAT_TAG_FAILED,
    DELETE_CHAT_TAG_STARTED,
    DELETE_CHAT_TAG_SUCCESS,
    DELETE_CHAT_TAG_FAILED,
    REORDER_CHAT_TAGS_STARTED,
    REORDER_CHAT_TAGS_SUCCESS,
    REORDER_CHAT_TAGS_FAILED,
} from "./chatTagConstants";
import axios from "axios";

// Get all chat tags
export const getChatTags = (params = {}) => {
    return (dispatch) => {
        dispatch({ type: GET_CHAT_TAGS_STARTED });

        axios({
            method: "get",
            url: `${process.env.REACT_APP_API_URL}chat-tags`,
            params: params,
        })
            .then((response) => {
                dispatch({
                    type: GET_CHAT_TAGS_SUCCESS,
                    payload: { chatTags: response.data },
                });
            })
            .catch((error) => {
                dispatch({
                    type: GET_CHAT_TAGS_FAILED,
                    payload: { error: error.response },
                });
            });
    };
};

// Create a new chat tag
export const createChatTag = (tagData) => {
    return (dispatch) => {
        dispatch({ type: CREATE_CHAT_TAG_STARTED });

        return axios({
            method: "post",
            url: `${process.env.REACT_APP_API_URL}chat-tags`,
            data: tagData,
        })
            .then((response) => {
                dispatch({
                    type: CREATE_CHAT_TAG_SUCCESS,
                    payload: { chatTag: response.data },
                });
                return response.data;
            })
            .catch((error) => {
                dispatch({
                    type: CREATE_CHAT_TAG_FAILED,
                    payload: { error: error.response },
                });
                throw error;
            });
    };
};

// Update an existing chat tag
export const updateChatTag = (id, tagData) => {
    return (dispatch) => {
        dispatch({ type: UPDATE_CHAT_TAG_STARTED });

        return axios({
            method: "put",
            url: `${process.env.REACT_APP_API_URL}chat-tags/${id}`,
            data: tagData,
        })
            .then((response) => {
                dispatch({
                    type: UPDATE_CHAT_TAG_SUCCESS,
                    payload: { chatTag: response.data },
                });
                return response.data;
            })
            .catch((error) => {
                dispatch({
                    type: UPDATE_CHAT_TAG_FAILED,
                    payload: { error: error.response },
                });
                throw error;
            });
    };
};

// Delete a chat tag
export const deleteChatTag = (id) => {
    return (dispatch) => {
        dispatch({ type: DELETE_CHAT_TAG_STARTED });

        return axios({
            method: "delete",
            url: `${process.env.REACT_APP_API_URL}chat-tags/${id}`,
        })
            .then((response) => {
                dispatch({
                    type: DELETE_CHAT_TAG_SUCCESS,
                    payload: { id },
                });
                return response.data;
            })
            .catch((error) => {
                dispatch({
                    type: DELETE_CHAT_TAG_FAILED,
                    payload: { error: error.response },
                });
                throw error;
            });
    };
};

// Reorder chat tags
export const reorderChatTags = (tags) => {
    return (dispatch) => {
        dispatch({ type: REORDER_CHAT_TAGS_STARTED });

        return axios({
            method: "post",
            url: `${process.env.REACT_APP_API_URL}chat-tags/reorder`,
            data: { tags },
        })
            .then((response) => {
                dispatch({
                    type: REORDER_CHAT_TAGS_SUCCESS,
                    payload: { tags },
                });
                return response.data;
            })
            .catch((error) => {
                dispatch({
                    type: REORDER_CHAT_TAGS_FAILED,
                    payload: { error: error.response },
                });
                throw error;
            });
    };
};
